import { useInstanceKey } from 'app/area/favourite/favourite-context';
import { selectExposure } from 'app/area/favourite/selectors';
import { ReportCommonApi } from 'app/area/reports/types-api';
import { codeItemToStoreValue } from 'app/infrastructure/data/codes';
import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actionCreators } from './actions';

export function useActionCreators(api: ReportCommonApi) {
  const dispatch = useDispatch();
  const instanceKey = useInstanceKey();
  return useMemo(() => bindActionCreators(actionCreators(api, instanceKey), dispatch), [dispatch, instanceKey]);
}

export function useWorkingDefinitionExposureState() {
  const instanceKey = useInstanceKey();

  const {
    exposureApplication,
    exposureFactor,
    exposurePercent
  } = useSelector(selectExposure(instanceKey));

  return {
    selectedExposureApplication: codeItemToStoreValue(exposureApplication),
    selectedExposureFactor: exposureFactor === 0 ? undefined : exposureFactor,
    selectedExposurePercent: exposurePercent === 0 ? undefined : exposurePercent
  };
}

export function useLoadDistributionDefaultFieldsEffect(api: ReportCommonApi) {
  const {
    loadDistributionDefaultFields,
    clearState
  } = useActionCreators(api);

  useEffect(() => {
    loadDistributionDefaultFields();
    return () => {
      clearState();
    };
  }, []);
}
